import api from "../api/api";

export const getData = async (url, params, query) => {
  let _params = "";
  if (params) {
    _params = params;
  }
  try {
    const response = await api.get(url + _params, { params: query });
    if (response.status === 200) {
      return response.data;
    }
    return null;
  } catch (err) {
    console.error(err);
    return false;
  }
};

export const postData = async (url, body) => {
  try {
    const response = await api.post(url, body);
    if (response.status === 201 || response.status === 200) {
      return response.data;
    }
    return null;
  } catch (err) {
    console.error(err);
    return false;
  }
};
export const patchData = async (url, body) => {
  try {
    const response = await api.patch(url, body);
    if (response.status === 201 || response.status === 200) {
      return response.data;
    }
    return null;
  } catch (err) {
    console.error(err);
    return false;
  }
};

export const putData = async (url, body) => {
  try {
    const response = await api.put(url, body);
    if (response.status === 200) {
      return response.data;
    }
    return null;
  } catch (err) {
    console.error(err);
    return false;
  }
};
